import React, { FC, ReactNode } from "react";
import { AdminSidebar } from "./components/Sidebar";
import AdminNavbar from "./components/AdminNavbar";


interface Props {
    heading: ReactNode;
    subHeading?: ReactNode;
    sidebar?: React.ReactNode
    children?: ReactNode;
}

export const AdminLayout: FC<Props> = ({
    heading,
    subHeading = (<></>),
    sidebar = <AdminSidebar />,
    children,
}) => {
    return (
        <>
            <div
                className={
                    "min-h-screen h-screen min-w-screen w-screen flex " +
                    "bg-light dark:!bg-brand-900 text-brand-700 hover:text-brand-700 dark:text-white dark:hover:text-white " +
                    "transition-colors duration-300"
                }
            >
                <div className="flex flex-row flex-grow overflow-hidden">
                    <div className="flex-none h-full overflow-hidden p-2">
                        {sidebar}
                    </div>
                    <div className="flex-grow flex flex-col overflow-auto py-2 pl-4 pr-0">
                        <AdminNavbar heading={heading} subHeading={subHeading} />
                        <div className="min-h-0 min-w-0 flex-grow flex-shrink my-6">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLayout;